const colors = {
    grey_0: '#161a21',
    grey_1: '#1c212a',
    grey_2: '#252e40',
    grey_3: '#abadc2',
    grey_4: '#6B6C83',
    grey_5: '#515867',
    grey_6: '#D4D6D9',
    grey_7: 'rgba(0,0,0,0.2)',
    grey_8: '#08131e',
    grey_9: '#0d0f13',
    grey_10: '#474a54',
    grey_11: '#6a6a83',
    grey_12: '#31363d',
    grey_13: '#7d8997',
    grey_14: '#dedfe5',
    red: '#f44336',
    red_1: '#d0011b',
}
export default Object.assign({}, colors, {
    transparentBlack: 'rgba(41,42,58,.7)',
    orange: '#FFAB00',
    white: '#fff',
    darkWhite: '#a5a7ab',
    teal: '#00cbf5',
    grey_2_1_gradient: `radial-gradient(circle at 75% 0, ${colors.grey_2}, ${colors.grey_1})`,
    blue_gradient: 'linear-gradient(69deg, #0ea1d4, #4bd0fe)',
    yellow: '#ffab00',
    yellow_hover: '#e69a00',
    yellow_active: '#ffb31a',
    blue: '#1eb0fc',
    blue_hover: '#0091ea',
    blue_active: '#40c4ff',
    lightBlue: '#00B5D1',
    green: '#04b730',
    green_hover: '#039e29',
    green_active: '#05d037',
    green_transparent: 'rgb(0, 230, 118)',
    black: '#000',
    dark_blue: 'rgb(8,19,30)',
    dark_blue_transparent_9: 'rgba(8, 19, 30, 0.9)', //#08131e
    dark_blue_transparent_8: 'rgba(8, 19, 30, 0.8)',
    dark_blue_transparent_3: 'rgba(8, 19, 30, 0.3)',
    map_beige: '#E5E3DF',
    payment: {
        facebook_blue: '#31436d',
        google_grey: '#fafafa',
        guest_blue: '#00a5ff',
    },
    map_background_color: '#E5E3DF',
    /* action buttons */
    action_buttons: {
        label_color: '#fff',

        one: '#FEBC48',
        one_hover: '#e69a00',
        one_active: '#ffb31a',

        two: '#05DC5D',
        two_hover: '#039e29',
        two_active: '#05d037',

        three: '#28BBFD',
        three_hover: '#0091ea',
        three_active: '#40c4ff',

        registration: '#ed145b',
        registration_hover: '#c50644',
        registration_active: '#c50644',
    },
    share: {
        email: '#ea4335',
        link: '#00b488',
        twitter: '#1da1f2',
        linkedin: '#0077b5',
        facebook: '#3b5998',
        instagram: '#f56040',
        active: {
            email: '#ea746a',
            link: '#02d4a1',
            twitter: '#45b0f1',
            linkedin: '#0291dc',
            facebook: '#4e75c7',
            instagram: '#f56040',
        },
    },
})
